module.exports = __webpack_public_path__ + "img/jamef.f69775c6.svg";